<template>
  <div class="bg-black/90 max-w-7xl mx-auto">
    <Transition
      name="scale-fade-in"
      appear
    >
      <section class="h-[300px] xs:[330px] sm:[340px] md:h-[440px] lg:h-[550px]">
        <div class="w-full h-full bg-[url(@/assets/images/views/event-list/banner.webp)] bg-cover bg-no-repeat bg-bottom">
          <div
            class="h-full w-full flex flex-col items-center justify-end pb-10 lg:pb-20 xl:pb-24 mx-auto bg-primary/50 md:bg-transparent"
            style="transition: all 100ms ease, background-color 400ms ease;"
          >
            <div class="w-full container-padding max-w-5xl">
              <h1 class="text-white text-4xl sm:text-5xl mb-8 banner-text-shadow">
                Focus on the Game,
                <br>
                Frame the Glory.
              </h1>

              <slot />

              <!-- Events Search Form -->
            </div>
          </div>
        </div>
      </section>
    </Transition>
  </div>
</template>

<script setup>

</script>
